import { string, object } from 'yup';

export const projectSchema = object().shape({
  projectName: string().required('Project name is required!'),
  status: string().required('Status is required!'),
});
